'use client';

import {useTranslations} from 'next-intl';
import {useMemo} from 'react';
import {Button} from '../../../../../../components/design-system';
import useFilters from '../hooks/useFilters';
import FilterCategory from './FilterCategory';
import FilterCharacteristic from './FilterCharacteristic';
import FilterLocation from './FilterLocation';
import FilterOccasion from './FilterOccasion';
import FilterPrice from './FilterPrice';
import FilterSort from './FilterSort';
import {Chip} from '@/components/design-system';
import AiStars from '@/components/icons/AiStars';
import {Link} from '@/i18n/routing';

export default function FilterBar() {
  const t = useTranslations('shop');

  const {filters, reset} = useFilters();

  const hasFiltersApplied = useMemo(() => {
    const count =
      (filters.category || []).length +
      (filters.subcategory || []).length +
      (filters.country || []).length +
      (filters.region || []).length +
      (filters.occasion || []).length +
      (filters.characteristic || []).length +
      (filters.priceMin ? 1 : 0) +
      (filters.priceMax ? 1 : 0);
    return count > 0;
  }, [
    filters.category,
    filters.subcategory,
    filters.country,
    filters.region,
    filters.priceMin,
    filters.priceMax,
    filters.occasion,
    filters.characteristic,
  ]);

  return (
    <div
      className={`
    container mx-auto flex flex-nowrap items-center gap-2
    pb-3 px-4 lg:px-6 xl:px-8 overflow-x-auto md:overflow-visible
  `}
    >
      <Link
        // @ts-expect-error
        href={{pathname: '/otto'}}
      >
        <Chip className="inline w-auto whitespace-nowrap">
          <div className="flex items-center gap-1">
            <AiStars width={20} height={15} />
            <span>{t('otto')}</span>
          </div>
        </Chip>
      </Link>
      {hasFiltersApplied && (
        <>
          <Button
            className="text-sm -mx-2"
            size="sm"
            theme="ghost"
            onClick={() => reset()}
          >
            {t('filter.reset')}
          </Button>
          <div className="w-px shrink-0 h-6 bg-greyscale-separator" />
        </>
      )}
      <FilterCategory />
      <FilterPrice />
      <FilterLocation />
      <FilterCharacteristic />
      <FilterOccasion />
      <FilterSort />
    </div>
  );
}
